import { isNil } from 'lodash';

/**
 * Build a deep-populate tree for a given path
 *
 * @param path the dot notation formatted path
 * @returns the populate object tree
 */
function _buildPopulatePath(path: string): any {
    const segments = path.split('.');

    let deep: any = undefined;

    while (segments.length > 0) {
        const segment = segments.pop();

        deep = !isNil(deep)
            ? {
                  path: segment,
                  populate: { ...deep },
              }
            : { path: segment };
    }

    return deep;
}

/**
 * Build a Mongoose-compatible array of deep-populate trees from an array of property paths
 *
 * @param paths an array of property paths
 * @returns an array of deep-populate trees
 */
export function buildDeepPopulate(paths: string[]): any {
    return paths.map(path => _buildPopulatePath(path));
}
